<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-row class="pl-3">
              <v-col cols="12" class="content_category rounded-lg d-flex">
                <h3 class="mt-2">Banner</h3>
                <v-btn
                  class="ml-5 mb-5"
                  color="primary"
                  @click="addBanner()"
                >
                  Thêm
                </v-btn>
              </v-col>
              
              <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index"> </form-link>
              </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" class="content_category mb-3 rounded-lg">
            <v-row class="pl-3">
              <v-col cols="12" class="content-textarea rounded-lg">
                <h3 class="my-2">Mô tả</h3>
                <v-textarea
                    background-color="#EDF2F7"
                    filled
                    label="Mô tả"
                    v-model="description"
                    placeholder="Nhập mô tả ngắn"
                >
                </v-textarea>
              </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Top categories</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addCategoryTop()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(item, index) in topCategories"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.category_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="categories"
                          label="Topcategory"
                          placeholder="Chọn category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearCategoryTop(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2 mb-3">Cấu hình số lượng sản phẩm hiển thị trên 1 hàng </h3>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số lượng phần tử hiện thị trên 1 hàng"
                            v-model="number_product_on_row"
                            placeholder="Nhập số lượng"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số lượng phần tử hiện thị trên 1 hàng giao diện mobile"
                            v-model="number_product_on_row_mobile"
                            placeholder="Nhập số lượng"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Categories có hiển thị sản phẩm</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addCategory()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(item, index) in categoryIds"
                    :key="index"
                  >
                    <v-row class="mb-3">
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.category_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="categories"
                          label="Topcategory"
                          placeholder="Chọn category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            :text="item.limit"
                            v-model="item.limit"
                            label="Số lượng sản phẩm"
                            placeholder="Số lượng sản phẩm"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearCategory(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import {
  GET_LIST_CONFIG_BOSCH,
  UPDATE_LIST_CONFIG_BOSCH,
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";

export default {
  components: { FormLink },
  data() {
    return {
      description: '',
      categoryIds: [],
      number_product_on_row:null,
      number_product_on_row_mobile:null,
      topCategories: [],
      banners: [],
      banner: {
          alt_image: "",
          alt_image_mobile: "",
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",
      src_banner_mobile: "",
      src_banner_desktop: "",
      category: {
        id: -1,
      },

      page: "Quản lý Bosch",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Bosch",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      config_bosch: "config_bosch",
      //   category: "categoryDetail",
      //   brands: "brands",
      //   tags: "tags",
      //   seos: "seos",
    }),
  },
  watch: {
    config_bosch(val) {
      this.banners = val.banner ?? [];
      this.description = val.description ?? '';
      this.topCategories = val.topCategories ?? [];
      this.categoryIds = val.categories.ids ?? [];
      this.number_product_on_row = val.categories.number_product_on_row ?? null;
      this.number_product_on_row_mobile = val.categories.number_product_on_row_mobile ?? null;
    }
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_BOSCH}`);
    // await this.$store.dispatch(`${GET_LIST_TAG}`);
  },
  mounted() {},
  methods: {
    addCategoryTop() {
      this.topCategories.push({
        category_id: this.category.id,
      });
    },
    addCategory() {
      this.categoryIds.push({
        category_id: this.category.id,
        limit: 0,
      });
    },
    save() {
      let body = {
        banner: this.banners,
        description: this.description,
        categories: {
          ids: this.categoryIds,
          number_product_on_row: this.number_product_on_row,
          number_product_on_row_mobile: this.number_product_on_row_mobile
        },
        topCategories: this.topCategories,
      };
      this.$store.dispatch(`${UPDATE_LIST_CONFIG_BOSCH}`, body).then((data) => {
        if (data.status === 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$store.dispatch(`${GET_LIST_CONFIG_BOSCH}`);
          this.$forceUpdate();
        } else {
          alert(data.errors);
        }
      });
    },
    clearCategory(i) {
      this.categoryIds.splice(i, 1);
      this.$forceUpdate();
    },
    clearCategoryTop(i) {
      this.topCategories.splice(i, 1);
      this.$forceUpdate();
    },
    addBanner() {
      this.banners.push({
        alt_image: this.banner.alt_image,
        alt_image_mobile: this.banner.alt_image_mobile,
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>